import { Link, Toast, ToastTitle, ToastTrigger } from "@fluentui/react-components";
import { memo } from "react";

type ToastMessageProps = {
  message: string;
  toastId: string;
  onDismiss: (id: string) => void;
};

export const ToastMessage = memo(({ message, toastId, onDismiss }: ToastMessageProps) => {
  return (
    <Toast>
      <ToastTitle
        action={
          <ToastTrigger>
            <Link onClick={() => onDismiss(toastId)}>Dismiss</Link>
          </ToastTrigger>
        }
      >
        {message}
      </ToastTitle>
    </Toast>
  );
});
